import { useQuery } from "@tanstack/react-query";
import {
  auditLogService,
  AuditLogFilters,
} from "../../services/admin/auditLog.service";

export function useAuditLogs(filters: AuditLogFilters) {
  return useQuery({
    queryKey: ["audit-logs", filters],
    queryFn: () => auditLogService.getAll(filters),
    placeholderData: (previousData) => previousData,
  });
}

export function useAuditLogsForResource(type: string, id: string) {
  return useQuery({
    queryKey: ["audit-logs", "resource", type, id],
    queryFn: () => auditLogService.getForResource(type, id),
    enabled: !!type && !!id,
  });
}

export function useAuditLogsForUser(userId: string) {
  return useQuery({
    queryKey: ["audit-logs", "user", userId],
    queryFn: () => auditLogService.getForUser(userId),
    enabled: !!userId,
  });
}
